import React, { useState, useEffect } from "react";
import logo from '../../assets/images/logonMyh.png'
import { useNavigate, useLocation } from "react-router-dom";
import { HiMenu, HiX, HiLink, HiQrcode, HiDocumentDuplicate, HiDocument } from "react-icons/hi";

export default function Header() {
    const navigator = useNavigate();
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    // Close mobile menu when screen size changes to desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) { // lg breakpoint
                setIsMobileMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Close mobile menu when route changes
    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location.pathname]);

    const navItems = [
        {
            path: '/',
            label: 'Rút gọn link',
            icon: HiLink,
            color: 'bg-blue-600 hover:bg-blue-700',
            description: 'Tạo liên kết ngắn gọn'
        },
        {
            path: '/create-qr',
            label: 'Tạo QR',
            icon: HiQrcode,
            color: 'bg-green-600 hover:bg-green-700',
            description: 'Tạo mã QR đơn lẻ'
        },
        {
            path: '/create-multi-qr',
            label: 'QR nhiều',
            icon: HiDocumentDuplicate,
            color: 'bg-amber-600 hover:bg-amber-700',
            description: 'Tạo nhiều mã QR cùng lúc'
        },
        {
            path: '/qr-document',
            label: 'QR tài liệu',
            icon: HiDocument,
            color: 'bg-red-600 hover:bg-red-700',
            description: 'Tạo QR cho tài liệu'
        }
    ];

    const isActive = (path) => location.pathname === path;

    const handleNavigation = (path) => {
        navigator(path);
        setIsMobileMenuOpen(false);
    };
  return (
    <header className="w-full bg-white shadow-lg border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Top Section */}
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src={logo}
              alt="Logo"
              className="h-10 w-auto md:h-12 cursor-pointer transition-transform hover:scale-105"
              onClick={() => handleNavigation('/')}
            />
          </div>

          {/* Desktop Navigation - Hidden on screens smaller than lg */}
          <nav className="hidden lg:flex items-center space-x-2">
            {navItems.map((item) => {
              const IconComponent = item.icon;
              return (
                <button
                  key={item.path}
                  onClick={() => handleNavigation(item.path)}
                  className={`group relative flex items-center space-x-2 px-4 py-2.5 rounded-lg font-medium text-sm transition-all duration-200 ${
                    isActive(item.path)
                      ? `${item.color} text-white shadow-md transform scale-105`
                      : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                  }`}
                  title={item.description}
                >
                  <IconComponent className="h-5 w-5" />
                  <span>{item.label}</span>
                  
                  {/* Active indicator */}
                  {isActive(item.path) && (
                    <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-white rounded-full"></div>
                  )}
                </button>
              );
            })}
          </nav>

          {/* Mobile Menu Button - Show on screens smaller than lg */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <HiX className="h-6 w-6" />
            ) : (
              <HiMenu className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Navigation - Show on screens smaller than lg */}
      <div className={`lg:hidden bg-white border-t border-gray-100 transition-all duration-300 ease-in-out ${
        isMobileMenuOpen 
          ? 'max-h-screen opacity-100 visible' 
          : 'max-h-0 opacity-0 invisible overflow-hidden'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
          <nav className="grid grid-cols-1 gap-2">
            {navItems.map((item) => {
              const IconComponent = item.icon;
              return (
                <button
                  key={item.path}
                  onClick={() => handleNavigation(item.path)}
                  className={`flex items-center space-x-3 p-4 rounded-lg text-left transition-all duration-200 w-full ${
                    isActive(item.path)
                      ? `${item.color} text-white shadow-md`
                      : 'text-gray-700 hover:bg-gray-50 border border-gray-200'
                  }`}
                >
                  <IconComponent className="h-5 w-5 flex-shrink-0" />
                  <div className="flex-1">
                    <div className="font-medium text-sm">{item.label}</div>
                    <div className={`text-xs mt-1 ${isActive(item.path) ? 'text-white/80' : 'text-gray-500'}`}>
                      {item.description}
                    </div>
                  </div>
                </button>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Mobile backdrop - Higher z-index */}
      {isMobileMenuOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black/30 backdrop-blur-sm -z-10" 
          onClick={() => setIsMobileMenuOpen(false)}
          style={{ top: '0' }}
        ></div>
      )}
    </header>
  );
}
